import * as THREE from 'three'
import Experience from '../Experience'

export default class North {
  constructor() {
    //setup
    this.experience = new Experience()
    this.scene = experience.scene
    this.resources = experience.resources
    this.time = experience.time
    this.debug = experience.debug
    //Options
    this.resource = this.resources.items.north

    //Methods
    this.setMaterial()
    this.setModel()
    this.hidePart()
  }
  setMaterial() {
    //structure
    this.structureTexture = this.resources.items.structureTexture
    this.structureTexture.flipY = false
    this.structureTexture.encoding = THREE.sRGBEncoding
    this.structureMaterial = new THREE.MeshBasicMaterial({ map: this.structureTexture })

    //roof
    this.roofTexture = this.resources.items.roofTexture
    this.roofTexture.flipY = false
    this.roofTexture.encoding = THREE.sRGBEncoding
    this.roofMaterial = new THREE.MeshBasicMaterial({ map: this.roofTexture })

    //pillar
    this.pillarTexture = this.resources.items.pillarTexture
    this.pillarTexture.flipY = false
    this.pillarTexture.encoding = THREE.sRGBEncoding
    this.pillarMaterial = new THREE.MeshBasicMaterial({ map: this.pillarTexture })

    //stair
    this.stairTexture = this.resources.items.stairsTexture
    this.stairTexture.flipY = false
    this.stairTexture.encoding = THREE.sRGBEncoding
    this.stairMaterial = new THREE.MeshBasicMaterial({ map: this.stairTexture })

    //chair
    this.chairTexture = this.resources.items.chairTexture
    this.chairTexture.flipY = false
    this.chairTexture.encoding = THREE.sRGBEncoding
    this.chairMaterial = new THREE.MeshBasicMaterial({ map: this.chairTexture })

    //detail
    this.detailTexture = this.resources.items.detailTexture
    this.detailTexture.flipY = false
    this.detailTexture.encoding = THREE.sRGBEncoding
    this.detailMaterial = new THREE.MeshBasicMaterial({ map: this.detailTexture })

    //drapeau breton
    this.drapeauTexture = this.resources.items.drapeauTexture
    this.drapeauTexture.flipY = false
    this.drapeauTexture.encoding = THREE.sRGBEncoding
    this.drapeauMaterial = new THREE.MeshBasicMaterial({ map: this.drapeauTexture })

    //drapeau SRFC
    this.srfcTexture = this.resources.items.srfcTexture
    this.srfcTexture.flipY = false
    this.srfcTexture.encoding = THREE.sRGBEncoding
    this.srfcMaterial = new THREE.MeshBasicMaterial({ map: this.srfcTexture })

    //super U
    this.superuTexture = this.resources.items.superuTexture
    this.superuTexture.flipY = false
    this.superuTexture.encoding = THREE.sRGBEncoding
    this.superuMaterial = new THREE.MeshBasicMaterial({ map: this.superuTexture })

    //Hermine
    this.hermineTexture = this.resources.items.hermineTexture
    this.hermineTexture.flipY = false
    this.hermineTexture.encoding = THREE.sRGBEncoding
    this.hermineMaterial = new THREE.MeshBasicMaterial({ map: this.hermineTexture, transparent: true })

    //banner
    this.bannerTexture = this.resources.items.bannerTexture
    this.bannerTexture.flipY = false
    this.bannerTexture.encoding = THREE.sRGBEncoding
    this.bannerMaterial = new THREE.MeshBasicMaterial({ map: this.bannerTexture })

    //logo
    this.logoTexture = this.resources.items.logoTexture
    this.logoTexture.flipY = false
    this.logoTexture.encoding = THREE.sRGBEncoding
    this.logoMaterial = new THREE.MeshBasicMaterial({ map: this.logoTexture, transparent: true })
  }
  setModel() {
    this.model = this.resource.scene

    //Structure
    const structure = this.model.children.find(child => child.name === 'structure')
    structure.material = this.structureMaterial

    //Roof
    const roof = this.model.children.find(child => child.name === 'roof')
    roof.material = this.roofMaterial

    //pillar
    const pillar = this.model.children.find(child => child.name === 'pillar')
    pillar.material = this.pillarMaterial

    //stair
    const stair = this.model.children.find(child => child.name === 'stair')
    stair.material = this.stairMaterial

    //chair
    const chair = this.model.children.find(child => child.name === 'chair')
    chair.material = this.chairMaterial

    //detail
    const detail = this.model.children.find(child => child.name === 'detail')
    detail.material = this.detailMaterial

    //drapeaux
    const drapeau1 = this.model.children.find(child => child.name === 'drapeau002')
    drapeau1.material = this.drapeauMaterial
    const drapeau2 = this.model.children.find(child => child.name === 'drapeau003')
    drapeau2.material = this.drapeauMaterial
    const srfc = this.model.children.find(child => child.name === 'drapeau-01001')
    srfc.material = this.srfcMaterial

    //Superu
    const superu = this.model.children.find(child => child.name === 'superu002')
    superu.material = this.superuMaterial
    const superu1 = this.model.children.find(child => child.name === 'superu003')
    superu1.material = this.superuMaterial

    //Hermines
    const hermine = this.model.children.find(child => child.name === 'hermine008')
    hermine.material = this.hermineMaterial
    const hermine1 = this.model.children.find(child => child.name === 'hermine009')
    hermine1.material = this.hermineMaterial
    const hermine2 = this.model.children.find(child => child.name === 'hermine010')
    hermine2.material = this.hermineMaterial
    const hermine3 = this.model.children.find(child => child.name === 'hermine011')
    hermine3.material = this.hermineMaterial
    const hermine4 = this.model.children.find(child => child.name === 'hermine012')
    hermine4.material = this.hermineMaterial
    const hermine5 = this.model.children.find(child => child.name === 'hermine013')
    hermine5.material = this.hermineMaterial
    const hermine6 = this.model.children.find(child => child.name === 'hermine014')
    hermine6.material = this.hermineMaterial
    const hermine7 = this.model.children.find(child => child.name === 'hermine015')
    hermine7.material = this.hermineMaterial

    //Hermines
    const banner = this.model.children.find(child => child.name === 'banner005')
    banner.material = this.bannerMaterial
    banner.material.side = THREE.DoubleSide
    const banner1 = this.model.children.find(child => child.name === 'banner006')
    banner1.material = this.bannerMaterial
    const banner2 = this.model.children.find(child => child.name === 'banner007')
    banner2.material = this.bannerMaterial
    const banner3 = this.model.children.find(child => child.name === 'banner008')
    banner3.material = this.bannerMaterial
    const banner4 = this.model.children.find(child => child.name === 'banner009')
    banner4.material = this.bannerMaterial

    //Logo
    const logo = this.model.children.find(child => child.name === 'logo011')
    logo.material = this.logoMaterial

    this.model.scale.set(0.4, 0.4, 0.4)
    this.scene.add(this.model)
  }

  hidePart() {
    const ctrl = document.querySelector('.north .slider')
    ctrl.addEventListener('click', () => {
      this.model.traverse(child => {
        if (child instanceof THREE.Mesh && child.visible === true) {
          child.visible = false
        } else child.visible = true
      })
    })
  }
}
